<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t('purchase_order') }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link :to="{name: 'PurchaseOrder'}" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
        </li>
      </ul>
    </div>

    <div class="card table-list-card p-3 bg-white fs-7">
    <form @submit.prevent="submitBatch" enctype="multipart/form-data">
      <!-- Header Form Section -->
      <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("receiving_no")}}</label>
          <input type="text" class="form-control" v-model="batches.receiving_no" readonly/>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("receiving_date")}}</label>
          <input type="date" class="form-control" v-model="batches.receiving_date" @change="fetchReceivingNo" />
          <div v-if="errors.receiving_date" class="text-danger mt-2">
            <span>{{errors.receiving_date}}</span>
          </div>
        </div>

        

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>
            <FormDropdown
              v-model="batches.supplier_id"
              :options="formattedsuppliers"
              clearable
              @update:modelValue="selectSupplier"
              class="flex-grow-1"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.supplier_id">{{ errors.supplier_id }}</span>
          </div>
        </div>

        

        <div class="col-md-6" v-if="selectedSupplier">
          <div class="d-flex align-items-start" style="min-height: 45px;">
            <label class="form-label small mb-1" style="width: 100px; white-space: nowrap;">
              Supplier Info:
            </label>

            <div class="text-start" style="font-size: 1rem; line-height: 1.4; word-break: break-word;">
              {{ selectedSupplier.name }} -
              {{ selectedSupplier.phone_number }} -
              <strong>Due:</strong>
              <span :style="{ color: selectedSupplier.due_balance > 0 ? 'red' : 'green' }">
                ৳{{ selectedSupplier.due_balance || 0 }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t('requisition_no') }} <span class="text-danger">*</span></label>
            <FormDropdown
              v-model="requisition_id"
              :options="formattedRequisions"
              :placeholder="$t('requisition_no.')"
              clearable
              @update:modelValue="addItem"
              class="flex-grow-1"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.requisition_id">{{ errors.requisition_id }}</span>
          </div>
        </div>

      </div>

      <!-- Item Input Section -->
      <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
        
      </div>
      <!-- Items Table -->
      <div class="table-responsive mb-3 fixed-table">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>{{ $t("requisition_no") }}</th>
              <th>{{ $t("item_name") }}</th>
              <th>{{ $t("priority") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("unit_price") }}</th>
              <th>{{ $t("amount") }}</th>
              <th>{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in addedItems" :key="index">
              <td>{{ item.requisition?.requisition_no }}</td>
              <td>{{ item.item?.item_name }}</td>
              <td>{{ item.priority }}</td>
              <td>
                <input type="number" class="form-control" :placeholder="$t('quantity')" v-model="item.quantity" />
              </td>
              <td>
                <input type="number" class="form-control" :placeholder="$t('costing_unit_price')" v-model="item.unit_price" />
              </td>
              <td>{{item.quantity*item.unit_price}}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>



      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </form>
  </div>

</div>
</template>

<script>
import { todayLocal } from '@/utils';
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';
import debounce from 'lodash.debounce'

export default {
  components: {
    Vue3Datepicker,
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      batches: {
        supplier_id: null, 
        receiving_no: '', 
        receiving_date: todayLocal(),

      },
      requisition_id:null,
      requisitions:[],
      
      errors: {},
      errorMessage: "",
      
      addedItems: [],
      suppliers:[],
      selectedSupplier: null,
      due_balance:0,
      
      debouncedSearch: null
    };
  },

  mounted() {
    this.fetchDropdownData();
    this.fetchReceivingNo();
  },

  computed: {
    formattedRequisions() {
      return this.requisitions.map(item => ({ id: item.id, text: item.requisition_no }));
    },

    formattedsuppliers() {
      return this.suppliers.map(supplier => ({ id: supplier.id, text: supplier.name }));
    },

    
  },

  methods: {
      async fetchDropdownData() {
        try {
          const [
            requisitionsRes, supplierRes,
          ] = await Promise.all([
            this.$axios.get(apiUrls.purchase_requisition.get, {params:{status:'Issued'}}),
            this.$axios.get(apiUrls.inventory_supplier.get),
          ]);

          this.requisitions = requisitionsRes?.data || [];
          this.suppliers = supplierRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      async addItem() {
        if (!this.requisition_id) {
          this.toast.warning("Please select an Requisition first.");
          return;
        }

        // Frontend validation before adding to list
        this.errors = {};
        const requiredFields = [
          "supplier_id", "receiving_no", "receiving_date"
        ];
        requiredFields.forEach(field => {
          if (!this.batches[field]) this.errors[field] = this.$t('error.required');
        });

        if (Object.keys(this.errors).length > 0) {
          this.requisition_id = ''
          return;
        }

        this.addedItems = []

        const response = await this.$axios.get(apiUrls.purchase_requisition_items.get, {
            params: { requisition_id: this.requisition_id }
          });
        let items = response.data;

        for (const item of items) {
          const pt = {
            item:item.item,
            requisition:item.requisition,
            priority: item.priority,
            quantity: item.quantity,
            unit_price:0,
          }

          this.addedItems.push(pt);
        }

      },

      

      async fetchReceivingNo() {
        try {
          let res = await this.$axios.get(apiUrls.purchase_rq_order_number.get, {
            params: { type: 'po' }
          });
          this.batches.receiving_no = res.data.po_no;
        } catch (err) {
          console.error(err);
        }
      },

      

      async submitBatch() {
        if (!this.addedItems.length) {
          this.toast.warning("Please add at least one batch before submitting.");
          return;
        }

        try {
          const payload = {
            batches: this.addedItems,
            po_no: this.batches.receiving_no,
            po_date: this.batches.receiving_date,
            supplier_id: this.batches.supplier_id,
          };

          // if your API expects JSON
          const response = await this.$axios.post(apiUrls.purchase_order.post, payload );

          this.toast.success("Batches submitted successfully!");
          this.$router.push({name:"PurchaseOrder"});
          this.$emit("create_success");
          this.addedItems = [];
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors;
          }
        }
      },

      async selectSupplier(value) {
        // dropdown gives only the supplier id
        const supplierId = value;

        if (!supplierId) {
          this.selectedSupplier = null;
          this.due_balance = 0;
          return;
        }

        // get full object from loaded array
        const supplierObj = this.formattedsuppliers.find((s) => s.id === supplierId);

        try {
          const response = await this.$axios.get(`/supplier/due/${supplierId}`);
          this.selectedSupplier = {
            ...supplierObj,
            due_balance: response.data.due_balance,
            name: response.data.supplier_name,
            phone_number: response.data.supplier_phone
          };
          this.due_balance = response.data.due_balance;
        } catch (error) {
          console.error("Error fetching due balance:", error);
          this.due_balance = 0;
        }
      },

      cancelForm() {
        this.$router.push({name:"PurchaseOrder"});
      },

      removeItem(index) {
        this.addedItems.splice(index, 1);
      },

    },

  watch: {

  },

  created() {
    
  },
};
</script>

<style scoped>

/* Optional: adjust table and input heights */
.table td, .table th {
  vertical-align: middle;
}

.fixed-table {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

/* Modal Backdrop */
.confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Box */
.confirm-modal {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: fadeInScale 0.2s ease;
}

/* Header */
.confirm-header h4 {
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
}

/* Body Rows */
.confirm-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.confirm-row.due {
  color: #dc3545;
  font-weight: 600;
  font-size: 16px;
}

/* Buttons */
.confirm-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* Animation */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>

